import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PreferencesService } from '../services/preferences.service';
import { environment } from 'src/environments/environment';
import {  Router, NavigationStart, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { NotifierV2Service } from '../services/notifier-v2.service';

@Component({
    selector: 'app-v3',
    templateUrl: './v3.component.html',
    styleUrls: ['./v3.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class V3Component implements OnInit {

  constructor(public  translate         : TranslateService,
              private preferenceService : PreferencesService,
              private _router: Router,
              private notifierService: NotifierV2Service,
              private location : Location,
              private _activateRouter: ActivatedRoute) { 
   
    let appDefaultCulture = environment.DEFAULT_CULTURE;  
    translate.addLangs(['en', 'nb', 'no']);
    translate.use(appDefaultCulture);

    this.preferenceService.setCulture(appDefaultCulture);
  }

  ngOnInit(): void {
    this.preferenceService.load();
  }
}
